<div (click)="abrirPrematriculaDialog()" class="aluno-card">
  <div class="aluno-card-header">
    <mat-icon>add_circle</mat-icon>
    <h4>NOVA REMATRÍCULA {{ anoLetivo.toUpperCase() }}</h4>
    <h4>{{ nome.toUpperCase() }}</h4>
    <p>
      Solicite a rematrícula do(a) aluno(a) {{ nome.toUpperCase() }} para o Ano Letivo de {{ anoLetivo }}.
    </p>
  </div>

  <button mat-raised-button color="primary" >
    + SOLICITAR REMATRÍCULA
  </button>
</div>
